import { ChangeEvent, FC } from 'react';

interface ChecklistTextProps {
  label: string;
  description?: string | null;
  isRequired?: boolean;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string | null;
  onClear?: () => void;
}

const ChecklistText: FC<ChecklistTextProps> = ({
  label,
  description,
  isRequired,
  value,
  onChange,
  disabled,
  placeholder,
  helperText,
  onClear,
}) => {
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-sm font-semibold text-slate-800">
            {label}
            {isRequired ? <span className="ml-1 text-danger">*</span> : null}
          </p>
          {description ? <p className="mt-1 text-xs text-slate-500">{description}</p> : null}
        </div>
        {value && value.trim().length > 0 && onClear ? (
          <button
            type="button"
            className="text-[11px] font-medium text-slate-400 underline-offset-2 hover:text-slate-600 hover:underline disabled:opacity-50"
            onClick={onClear}
            disabled={disabled}
          >
            Clear
          </button>
        ) : null}
      </div>
      <textarea
        className="mt-3 w-full min-h-[96px] rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 shadow-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:bg-slate-50"
        value={value}
        onChange={handleChange}
        placeholder={placeholder ?? 'Add notes…'}
        disabled={disabled}
      />
      {helperText ? <p className="mt-2 text-xs text-danger">{helperText}</p> : null}
    </div>
  );
};

export default ChecklistText;
